import {
	request
} from '@/js_sdk/request.utils.js';

export function login(data) {
	return request({
		url: '/api/index/login',
		data
	})
}

export function sendCode(data) {
	return request({
		url: '/api/index/sendCode',
		data
	})
}

// whatsapp验证码
export function sendWhatsAppCode(data) {
	return request({
		url: '/api/index/sendWhatsAppCode',
		data
	})
}

export function userStepData(data) {
	return request({
		url: '/api/user/getStepInfo',
		data
	}, true, true)
}

export function initUserStepData(data) {
	return request({
		url: '/api/user/getStepInfo',
		data
	})
}

export function userInfo() {
	return request({
		url: '/api/user/info'
	})
}

// 未登录获取是不是新设备
export function newUserGetCouponInfo() {
	return request({
		url: '/newcomerGift/getCouponInfo',
		method: 'POST'
	})
}

//用户获取验证码与sessionId
export function getSessionIdAndCode(data) {
	return request({
		url: '/review/getSessionIdAndCode',
		data
	})
}

//通过公民数据库获取用户个人信息
export function getUserInfoFromCitizenLibrary(data) {
	return request({
		url: '/review/getUserInfoFromCitizenLibrary',
		data
	})
}

//获取用户公民数数据库信息(6位数获取)
export function getUserInfoFromCitizenLibraryNew(data) {
	return request({
		url: '/review/getUserInfoFromCitizenLibraryNew',
		data
	})
}

// 获取用户请求数据库次数
export function getUserInfoFromClCount(data) {
	return request({
		url: '/review/getUserInfoFromClCount',
		data
	})
}

// 用户选择的额度以及天数
export function userLoanInfo(data) {
	return request({
		url: '/api/user/loaninfo',
		method: 'POST',
		data
	})
}

// 神策埋点字段
export function getField(data) {
	return request({
		url: '/Sensors/getField',
		method: 'POST',
		data,
		header:{
			"Content-Type" : "application/x-www-form-urlencoded",
		}
	})
}

// 创建合同，发送短信
export function applicationCreate(data) {
	return request({
		url: '/api/fcb/application/create',
		method: 'POST',
		data
	})
}

// 签署合同,验证短信
export function applicationSign(data) {
	return request({
		url: '/api/fcb/application/sign',
		method: 'POST',
		data
	})
}

// 检查会话状态
export function applicationStatus(data) {
	return request({
		url: '/api/fcb/session/status',
		method: 'POST',
		data
	})
}

// 用户联系人1/2分流
export function contactGroup(data) {
	return request({
		url: '/contactGroup',
		method: 'POST',
		data
	})
}